const apiUrl = process.env.REACT_APP_API_URL;
export const GetJutgePracticaIdDocuments = async (id_practica: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${id_practica}/documents`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
